const setClassToButtons = ($buttons: HTMLElement[], classes: string) => {
    for(const $btn of $buttons) {
        $btn.className = classes;
    }
};

const loadCheckOsLogic = () => {
    const $windowsButtons = [...document.querySelectorAll(`[data-id="windowsButton"]`)] as HTMLElement[];
    const $macButtons = [...document.querySelectorAll(`[data-id="macButton"]`)] as HTMLElement[];
    const os = getOS();

    if(os === 'Windows') {
        setClassToButtons($windowsButtons, 'w-btn-win w-64');
        setClassToButtons($macButtons, 'w-btn-mac-outline w-64');
        return;
    }

    if(os === 'Mac OS' || os === 'iOS') {
        setClassToButtons($windowsButtons, 'w-btn-win-outline w-64');
        setClassToButtons($macButtons, 'w-btn-mac w-64');
    }
};

const checkIfOsLogicNeeded = () => {
    const $windowsButton = document.querySelector(`[data-id="windowsButton"]`);
    const $macButton = document.querySelector(`[data-id="macButton"]`);
    return !!($windowsButton && $macButton);
}

/**
* Function returns whether the os is windows/Mac
* */
const getOS = () => {
    let userAgent = window.navigator.userAgent;
    let platform = window.navigator.platform;
    let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    let iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = "";

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (/Linux/.test(platform)) {
        os = 'Linux';
    }
    return os;
}

document.addEventListener('DOMContentLoaded', () => {
    if (checkIfOsLogicNeeded()){
        loadCheckOsLogic();
    }
});